import { createFeature, createReducer, on } from '@ngrx/store';
import { OrganizationActions } from './organization.actions';
import { OrganizationModels } from '@share-models';

export declare interface OrganizationState {
  activeOrganizationDocument: OrganizationModels.OrganizationDocument | null;
  isDefaultOrganization: boolean;
  isSaving: boolean;
  userOrganizations: OrganizationModels.UserOrganizationDropDown[];
}

const initialState: OrganizationState = {
  activeOrganizationDocument: null,
  isDefaultOrganization: false,
  isSaving: false,
  userOrganizations: [],
};

export const organizationStateReducer = createReducer(
  initialState,
  on(OrganizationActions.resetToInitialState, () => {
    return {
      ...initialState,
    };
  }),
  on(
    OrganizationActions.setActiveOrganizationDocument,
    (state, { activeOrganizationDocument }) => {
      return {
        ...state,
        activeOrganizationDocument,
      };
    },
  ),
  on(
    OrganizationActions.getMyOrganizationsSuccess,
    (state, { userOrganizations }) => ({
      ...state,
      userOrganizations,
    }),
  ),
);

export const organizationFeature = createFeature({
  name: 'organization',
  reducer: organizationStateReducer,
});
